export const DEAL_PAYROLL_CATALOG_EMPTY_KEY = '';
export const DEAL_PAYROLL_CATALOG_EMPTY_LENGTH = 0;
export const DEAL_PAYROLL_CATALOG_INITIAL_SEQUENCE = 0;
export const DEAL_PAYROLL_CATALOG_STRING_TYPE = 'string';
export const DEAL_PAYROLL_CATALOG_LOAD_ERROR_KEY = 'DEAL_PAYROLL_CATALOG_LOAD_ERROR';
export const DEAL_PAYROLL_CONFIGURATION_READY_KEY = 'DEAL_PAYROLL_CONFIGURATION_READY';
export const DEAL_PAYROLL_CONFIGURATION_NEEDS_ATTENTION_KEY =
  'DEAL_PAYROLL_CONFIGURATION_NEEDS_ATTENTION';
export const DEAL_PAYROLL_CONFIGURATION_SERVER_DISABLED_KEY =
  'DEAL_PAYROLL_CONFIGURATION_SERVER_DISABLED';

export const DEAL_PAYROLL_RATES_CONFLICT_STATUS = 409;
export const DEAL_PAYROLL_RATES_LOAD_ERROR_KEY = 'DEAL_PAYROLL_RATES_LOAD_ERROR';
export const DEAL_PAYROLL_RATES_SAVE_ERROR_KEY = 'DEAL_PAYROLL_RATES_SAVE_ERROR';
export const DEAL_PAYROLL_RATES_STALE_KEY = 'DEAL_PAYROLL_SETTINGS_STALE';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/deal-payroll-catalog/deal-payroll-catalog.constants.ts